import PropTypes from 'prop-types';
import React from 'react';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';

import UnitSelector from 'src/component/UI/UnitSelector';
import FeatureFence from 'src/component/FeatureFence';

export default function FilterBar (props) {
  const {
    includeGrid
  } = props;

  let component = null;

  if (includeGrid) {
    component = (
      <Grid item xs={12} md={12}>
        <Paper>
          <UnitSelector />
        </Paper>
      </Grid>
    );
  } else {
    component = (
      <Paper>
        <UnitSelector />
      </Paper>
    );
  }

  return (<FeatureFence can='eht-process-data'>
    {component}
  </FeatureFence>);
}

FilterBar.propTypes = {
  includeGrid: PropTypes.bool
};

FilterBar.defaultProps = {
  includeGrid: false
};
